import withComponents from './components';
import withFeatureFlags from './feature-flags';
import withProps from './props';
import withRanking from './ranking';

/**
 * Prepares search results for rendering, filtering out unwanted results
 * and associating Vue components to the wanted results.
 *
 * This works by applying a set of generator functions on the result,
 * performing all of the above in one pass through the array and returning
 * a new array.
 *
 * @param {Iterable} results
 * @param {String} position `mainline` or `sidebar`
 * @param {Function} getFeatureToggle feature toggle getter. Undefined if Unleash not present.
 * @returns {Array} prepared results
 */
export default (results, position, getFeatureToggle) => [
  ...withRanking(
    withProps(
      withFeatureFlags(
        withComponents(
          results,
          position,
        ),
        getFeatureToggle,
      ),
    ),
  ),
];
